// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "unconfirmedTransaction.proto" (package "transaction", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { UnconfirmedTransactionService } from "./unconfirmedTransaction";
import type { PromoteUnconfirmedTransactionResponse } from "./unconfirmedTransaction";
import type { PromoteUnconfirmedTransactionRequest } from "./unconfirmedTransaction";
import type { DeleteUnconfirmedTransactionResponse } from "./unconfirmedTransaction";
import type { DeleteUnconfirmedTransactionRequest } from "./unconfirmedTransaction";
import type { UpdateUnconfirmedTransactionResponse } from "./unconfirmedTransaction";
import type { UpdateUnconfirmedTransactionRequest } from "./unconfirmedTransaction";
import type { CreateUnconfirmedTransactionResponse } from "./unconfirmedTransaction";
import type { CreateUnconfirmedTransactionRequest } from "./unconfirmedTransaction";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllUnconfirmedTransactionsResponse } from "./unconfirmedTransaction";
import type { GetAllUnconfirmedTransactionsRequest } from "./unconfirmedTransaction";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service transaction.UnconfirmedTransactionService
 */
export interface IUnconfirmedTransactionServiceClient {
    /**
     * @generated from protobuf rpc: GetAllUnconfirmedTransactions
     */
    getAllUnconfirmedTransactions(input: GetAllUnconfirmedTransactionsRequest, options?: RpcOptions): UnaryCall<GetAllUnconfirmedTransactionsRequest, GetAllUnconfirmedTransactionsResponse>;
    /**
     * @generated from protobuf rpc: CreateUnconfirmedTransaction
     */
    createUnconfirmedTransaction(input: CreateUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<CreateUnconfirmedTransactionRequest, CreateUnconfirmedTransactionResponse>;
    /**
     * @generated from protobuf rpc: UpdateUnconfirmedTransaction
     */
    updateUnconfirmedTransaction(input: UpdateUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<UpdateUnconfirmedTransactionRequest, UpdateUnconfirmedTransactionResponse>;
    /**
     * @generated from protobuf rpc: DeleteUnconfirmedTransaction
     */
    deleteUnconfirmedTransaction(input: DeleteUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<DeleteUnconfirmedTransactionRequest, DeleteUnconfirmedTransactionResponse>;
    /**
     * @generated from protobuf rpc: PromoteUnconfirmedTransaction
     */
    promoteUnconfirmedTransaction(input: PromoteUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<PromoteUnconfirmedTransactionRequest, PromoteUnconfirmedTransactionResponse>;
}
/**
 * @generated from protobuf service transaction.UnconfirmedTransactionService
 */
export class UnconfirmedTransactionServiceClient implements IUnconfirmedTransactionServiceClient, ServiceInfo {
    typeName = UnconfirmedTransactionService.typeName;
    methods = UnconfirmedTransactionService.methods;
    options = UnconfirmedTransactionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllUnconfirmedTransactions
     */
    getAllUnconfirmedTransactions(input: GetAllUnconfirmedTransactionsRequest, options?: RpcOptions): UnaryCall<GetAllUnconfirmedTransactionsRequest, GetAllUnconfirmedTransactionsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllUnconfirmedTransactionsRequest, GetAllUnconfirmedTransactionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateUnconfirmedTransaction
     */
    createUnconfirmedTransaction(input: CreateUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<CreateUnconfirmedTransactionRequest, CreateUnconfirmedTransactionResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateUnconfirmedTransactionRequest, CreateUnconfirmedTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateUnconfirmedTransaction
     */
    updateUnconfirmedTransaction(input: UpdateUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<UpdateUnconfirmedTransactionRequest, UpdateUnconfirmedTransactionResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateUnconfirmedTransactionRequest, UpdateUnconfirmedTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteUnconfirmedTransaction
     */
    deleteUnconfirmedTransaction(input: DeleteUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<DeleteUnconfirmedTransactionRequest, DeleteUnconfirmedTransactionResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteUnconfirmedTransactionRequest, DeleteUnconfirmedTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PromoteUnconfirmedTransaction
     */
    promoteUnconfirmedTransaction(input: PromoteUnconfirmedTransactionRequest, options?: RpcOptions): UnaryCall<PromoteUnconfirmedTransactionRequest, PromoteUnconfirmedTransactionResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<PromoteUnconfirmedTransactionRequest, PromoteUnconfirmedTransactionResponse>("unary", this._transport, method, opt, input);
    }
}
